import React, { useState, useEffect,useRef } from 'react';
import { Menu, X, Phone, Mail, Clock, Wrench,Scissors, Home, AlertCircle, Zap, Star, Award, Shield, Calculator, Search,Truck, ArrowLeft, Package, CloudRain, ChevronRight, ArrowRight, Users, Building, CheckCircle, TrendingUp, ChevronLeft, Grid, List, ShoppingCart, HardHat, PaintBucket, Droplets, Thermometer, Layers, Send, Calendar, DollarSign, Bath, Target, Hammer, Handshake, Cpu, Microscope, Quote, MapPin} from 'lucide-react';

import { Trabajo, Producto, Servicio, PhoneNumber } from '../types';

// Componente para el selector de teléfonos
export default function PhoneSelector({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const phoneNumbers: PhoneNumber[] = [
    { name: "Oficina", number: "+34 953 03 95 67", description: "Teléfono principal" },
    { name: "Oficina 2", number: "+34 953 96 49 66", description: "Línea secundaria" },
    { name: "Móvil Oficina", number: "+34 650 44 13 96", description: "WhatsApp y llamadas" },
    { name: "José Luis", number: "+34 609 54 17 74", description: "Dirección / Consultas" }
  ];
  
  const handleCall = (phoneNumber: string) => {
    window.location.href = `tel:${phoneNumber}`;
    onClose();
  };
  
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold text-gray-800">Selecciona un número</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="h-6 w-6" />
            </button>
          </div>
          
          <div className="space-y-3">
            {phoneNumbers.map((phone, index) => (
              <button
                key={index}
                onClick={() => handleCall(phone.number)}
                className="w-full text-left p-4 border border-gray-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-all duration-200 group"
              >
                <div className="flex items-center">
                  <Phone className="h-5 w-5 text-blue-600 mr-3 group-hover:scale-110 transition-transform" />
                  <div>
                    <p className="font-semibold text-gray-800">{phone.name}</p>
                    <p className="text-blue-600 font-medium">{phone.number}</p>
                    <p className="text-sm text-gray-600">{phone.description}</p>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

